import clsx from 'clsx';

export const section = clsx('py-20', 'bg-darkBackground', 'text-center');

export const title = clsx(
  'title',
  'text-[26px]',
  'md:text-3xl',
  'font-semibold',
  '-mb-6',
  'text-title',
  'text-center'
);

export const container = clsx('max-w-[100%]', 'mx-auto', 'relative');

export const arrow = clsx(
  'absolute',
  'top-1/2',
  '-translate-y-1/2',
  'z-10',
  'cursor-pointer',
  'select-none',
  'p-1',
  'transition-transform',
  'duration-300',
  'hover:scale-110'
);

export const leftArrow = clsx('left-1', 'md:left-4');

export const rightArrow = clsx('right-1', 'md:right-4');

export const image = clsx(
  'w-full',
  'object-contain',
  'rounded-2xl',
  'transition-all',
  'duration-500',
  'select-none',
  'draggable-none',
);

export const activeImage = clsx('blur-0', 'md:scale-90', 'scale-[85%]');

export const inactiveImage = clsx(
  'blur-[1px]',
  'md:scale-75',
  'scale-75',
  'opacity-20'
);

export const sliderContainer = clsx('rounded-xl', 'px-6');

export const button = clsx(
  'title',
  'inline-flex',
  'flex-row',
  'items-center',
  'justify-center',
  'gap-1.5',
  'bg-title',
  'text-white',
  'text-sm',
  'font-regular',
  'rounded-full',
  'shadow',
  'hover:opacity-90',
  'md:self-start',
  'self-center',
  'w-60',
  'h-12',
  '-md:mt-20',
  '-mt-10'
);
